import _taggedTemplateLiteral from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  width: 100%;\n  z-index: 1000;\n  border-bottom: 1px solid ", ";\n  background-color: ", ";\n\n  & > * {\n    line-height: ", "px;\n    padding: 0 20px;\n  }\n\n  /* Logo */\n  .header-logo img {\n    height: 30px;\n    margin-bottom: -5px;\n  }\n\n  /* env */\n  .header-env {\n    padding: 0 0;\n    margin: 6px 0 -8px 0px;\n  }\n\n  /* Title */\n  .header-title {\n    margin-right: auto;\n  }\n\n  .header-title h1 {\n    color: ", ";\n    font-size: 1.4em;\n    margin: 0;\n  }\n\n  .header-title h1 a {\n    color: ", ";\n    text-decoration: none;\n  }\n\n  /* Icon */\n  .header-dark {\n    background-color: ", ";\n    color: ", ";\n\n    svg {\n      fill: ", ";\n    }\n  }\n\n  .header-icon {\n    position: relative;\n    align-items: center;\n    padding: 0;\n    width: ", "px;\n    height: ", "px;\n    border-left: 1px solid ", ";\n  }\n\n  /* Notification */\n\n  .header-notification {\n    position: relative;\n    cursor: pointer;\n    transition: background-color 0.3s;\n  }\n\n  .header-notification-icon {\n    position: absolute;\n    top: 11px;\n    left: 11px;\n  }\n\n  .header-notification-badge {\n    position: absolute;\n    bottom: 5px;\n    right: 5px;\n  }\n\n  .header-notification:hover {\n    background-color: ", ";\n\n    .header-notification-menubox {\n      opacity: 1;\n      visibility: visible;\n    }\n  }\n\n  .header-notification-menubox {\n    opacity: 0;\n    visibility: hidden;\n    transition: opacity 0.3s;\n    background-color: ", ";\n    position: absolute;\n    top: ", "px;\n    right: 0;\n    min-width: 650px;\n    padding: ", "rem\n      ", "rem;\n    padding-right: 0;\n    border-radius: ", ";\n    z-index: 10;\n  }\n\n  .header-notification-menu {\n    color: ", ";\n    padding-right: ", "rem;\n    padding-top: ", "rem;\n    max-height: calc(70vh - ", "px);\n    overflow-y: auto;\n\n    svg {\n      fill: ", ";\n    }\n  }\n\n  /* Apps */\n\n  .header-apps {\n    min-width: 130px;\n    margin-left: auto;\n\n    .header-switch-menu {\n      min-width: 200px;\n    }\n  }\n\n  /* User */\n\n  .header-user-icon {\n    position: absolute;\n    top: 9px;\n    left: 12px;\n  }\n\n  .header-user .header-switch-menu {\n    border-radius: 0 0 0 ", ";\n  }\n\n  /* Switch menu */\n\n  .header-switch {\n    position: relative;\n    cursor: pointer;\n    transition: background-color 0.3s;\n  }\n\n  .header-switch:hover {\n    background-color: ", ";\n\n    .header-switch-menu {\n      opacity: 1;\n      visibility: visible;\n    }\n  }\n\n  .header-switch-menu {\n    opacity: 0;\n    visibility: hidden;\n    background-color: ", ";\n    position: absolute;\n    top: ", "px;\n    right: 0;\n    border-radius: ", ";\n    ", ";\n    transition: opacity 0.3s;\n    z-index: 10;\n\n    a {\n      display: block;\n      color: ", ";\n      text-decoration: none;\n      line-height: 1rem;\n      padding: ", "rem;\n      white-space: nowrap;\n      border-bottom: 1px solid ", ";\n\n      &:last-child {\n        border: 0;\n      }\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

/**
 * @file Created on Fri Jul 27 2018
 * @author VBr
 */
import styled, { withTheme } from 'styled-components';
/**
 *  Styled Header component
 */

var StyledHeader = styled.header(_templateObject(), function (props) {
  return props.theme.colors.border;
}, function (props) {
  return props.theme.colors.paper;
}, function (props) {
  return props.theme.header.height;
}, function (props) {
  return props.theme.colors.text;
}, function (props) {
  return props.theme.colors.text;
}, function (props) {
  return props.theme.colors.header;
}, function (props) {
  return props.theme.colors.inverse;
}, function (props) {
  return props.theme.colors.inverse;
}, function (props) {
  return props.theme.header.height;
}, function (props) {
  return props.theme.header.height;
}, function (props) {
  return props.theme.colors.border;
}, function (props) {
  return props.theme.colors.selected;
}, function (props) {
  return props.theme.colors.selected;
}, function (props) {
  return props.theme.header.height;
}, function (props) {
  return props.theme.spacing.spacer / 2;
}, function (props) {
  return props.theme.spacing.spacer;
}, function (props) {
  return [0, 0, props.theme.common.borderRadius, props.theme.common.borderRadius].join(' ');
}, function (props) {
  return props.theme.colors.text;
}, function (props) {
  return props.theme.spacing.spacer;
}, function (props) {
  return props.theme.spacing.spacer / 2;
}, function (props) {
  return props.theme.header.height;
}, function (props) {
  return props.theme.colors.text;
}, function (props) {
  return props.theme.common.borderRadius;
}, function (props) {
  return props.theme.colors.selected;
}, function (props) {
  return props.theme.colors.selected;
}, function (props) {
  return props.theme.header.height;
}, function (props) {
  return [0, 0, props.theme.common.borderRadius, props.theme.common.borderRadius].join(' ');
}, function (props) {
  return props.theme.common.borderRadius;
}, function (props) {
  return props.theme.colors.inverse;
}, function (props) {
  return props.theme.spacing.spacer;
}, function (props) {
  return props.theme.colors.text;
});
export default withTheme(StyledHeader);